import {
  Component,
  forwardRef,
  Input,
  ViewChild,
  ElementRef,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { Observable, Subject } from 'rxjs';

import { EWarehouseDefaultGroup } from './../../../invoice/interfaces/invoice.interface';
import { RfqApiService } from './../../services/api/rfq/rfq-api.service';

@Component({
  selector: 'lum-rfq-autocomplete',
  templateUrl: './rfq-autocomplete.component.html',
  styleUrls: ['./rfq-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RfqAutocompleteComponent),
      multi: true,
    },
  ],
})
export class RfqAutocompleteComponent implements ControlValueAccessor {
  @ViewChild('rfqInputRef', { static: true })
  rfqInputRef :ElementRef<HTMLInputElement>;

  @Input()
  index :number = 0;

  @Input()
  warehouseGroupId :number | null = null;

  @Input()
  disabled :boolean = false;

  @Output()
  selectedRfqEvent = new EventEmitter<any>();

  relation :string = [
    'category',
    'subcategory',
    'basePrice',
    'tags.tag_details',
    'images',
    'locationStock',
    'variantParent.category',
    'variantParent.subcategory',
    'variantParent.tags.tag_details',
    'variantParent.unitOfMeasures',
    'rfqAttachments',
    'unitOfMeasures',
    'quotations',
  ].join(',');
  queryParams :any = {
    relations: this.relation,
    sellable: '1',
    warehouse_group_id: EWarehouseDefaultGroup.DEFAULT.toString(),
    per_page: 50,
    offset: 0,
  };

  value :any = '';
  private onChange = (value :any) => {};
  private onTouched = () => {};

  constructor(private rfqApiService :RfqApiService) {}

  writeValue(value :any) :void {
    this.value = value;
    if (this.rfqInputRef) {
      this.rfqInputRef.nativeElement.value = this.value;
    }
  }

  registerOnChange(fn :any) :void {
    this.onChange = fn;
  }

  registerOnTouched(fn :any) :void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled :boolean) :void {
    if (isDisabled) {
      this.rfqInputRef.nativeElement.setAttribute('disabled', 'true');
    } else {
      this.rfqInputRef.nativeElement.removeAttribute('disabled');
    }
  }

  onInput(event :Event) :void {
    const inputElement = event.target as HTMLInputElement;
    this.value = inputElement.value;
    this.onChange(this.value);
  }

  onBlur() :void {
    this.onTouched();
  }

  onSearchRfq(sku :string) :void {
    this.queryParams.sku = sku;
    if (this.warehouseGroupId) {
      this.queryParams.warehouse_group_id = this.warehouseGroupId;
    }
    this.rfqApiService.search({
      ...this.queryParams,
    });
    // Custom logic for search
  }

  onEnterRfq(event :Event, item :any, index :number) :void {
    // Custom logic for enter key
  }

  onSelectSku(event :MatAutocompleteSelectedEvent) :void {
    this.selectedRfqEvent.emit(event.option.value);
  }

  onScrollPaginate() :void {
    // Custom logic for pagination
  }

  get displayValue() :string {
    return this.value && this.value.sku
      ? `${this.value.product_name}[${this.value.sku}]`
      : '';
  }

  get rfqs$() :Observable<any[]> {
    // Custom logic for fetching RFQs
    return this.rfqApiService.rfqs$;
  }

  get loadingRfqs$() :Observable<boolean> {
    return this.rfqApiService.loading$;
  }
}
